import type { components } from "@/shared/api";

export type SiteEvent = components["schemas"]["SiteEvent"];

type Umami = { track: (event: string) => unknown };

// Действия, уже отправленные с этой загрузки страницы.
const sent = new Set<SiteEvent>();

// Действие на странице — событием в Umami: только имя (`SiteEvent`), без данных о человеке.
// Дашборд считает посетителей, которые хоть раз сделали действие, поэтому одно и то же
// действие с одной загрузки страницы уходит один раз. Без трекера (dev, e2e, «Do Not Track»,
// скрипт ещё не загрузился) — ничего; ошибка трекера сайт не ломает.
export const trackEvent = (event: SiteEvent): void => {
  if (sent.has(event)) {
    return;
  }
  const umami = (window as { umami?: Partial<Umami> }).umami;
  if (typeof umami?.track !== "function") {
    return;
  }
  sent.add(event);
  try {
    umami.track(event);
  } catch {
    // Аналитика не мешает игроку.
  }
};
